/* build 2026-09-01e - CTA do editorial de Coroas passa a dizer Falar com a Edelweiss */
/* ==========================================================================
   Floricultura Edelweiss — páginas de listagem (PLP) e de produto (PDP).
   Depende de app.js, que expõe window.EDELWEISS.
   ========================================================================== */
(function () {
  'use strict';

  var E = window.EDELWEISS;
  if (!E) return;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = E.money;

  function param(nome) {
    return new URLSearchParams(location.search).get(nome);
  }
  /* Busca sem acento e sem caixa: quem digita "buque" tem de achar "Buquê".
     `normalize('NFD')` separa a letra do diacritico e o range apaga o diacritico. */
  function chave(t) {
    return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function icones() {
    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
  }
  function categoria(id) {
    return E.CATEGORIAS.filter(function (c) { return c.id === id; })[0] || null;
  }
  function produto(id) {
    return E.PRODUTOS.filter(function (p) { return p.id === id; })[0] || null;
  }

  /* ---------------------------------------------------------------
     PLP — listagem
     A pele CERIMÔNIA muda a ESTRUTURA, não a cor: vira lista, sem
     card, sem selo, sem nota, sem parcelamento em destaque.
     --------------------------------------------------------------- */
  function montarPLP() {
    var alvo = $('[data-listagem]');
    if (!alvo) return;

    var catId = param('cat');
    var cat = catId ? categoria(catId) : null;
    var itens = cat ? E.PRODUTOS.filter(function (p) { return p.cat === cat.id; }) : E.PRODUTOS;

    /* COLECAO REAL (15/10/2026). Em /collections/<handle> o collection.liquid
       escreve no [data-listagem] os SKUs da colecao (data-skus), o titulo e a
       categoria que define a pele. Sem `?cat=`, a grade mostra SO essas pecas,
       e o H1 que o servidor ja escreveu (o titulo da colecao) nao e trocado.
       Com `?cat=` ou `?q=` vale o comportamento antigo. */
    var colecao = null;
    if (!catId && alvo.getAttribute('data-colecao')) {
      var skus = (alvo.getAttribute('data-skus') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);
      colecao = { titulo: alvo.getAttribute('data-colecao-titulo') || '' };
      var catCol = alvo.getAttribute('data-colecao-cat');
      if (catCol) cat = categoria(catCol);
      /* Peças SOB CONSULTA (16/10/2026): não são produtos da Shopify, então não têm SKU na coleção.
         Nas 4 categorias principais entram também as peças sob consulta da mesma categoria. */
      var colPrincipal = ['buques', 'cestas-e-presentes', 'orquideas-e-plantas', 'coroas-de-flores']
        .indexOf(alvo.getAttribute('data-colecao')) !== -1;
      itens = E.PRODUTOS.filter(function (p) {
        return skus.indexOf(String(p.id)) !== -1 ||
          (colPrincipal && p.sobConsulta && catCol && p.cat === catCol);
      });
    }

    /* BUSCA (19/08/2026) — vem da barra do hero da home, `/collections/all?q=`.
       Procura no nome, no resumo e no NOME DA CATEGORIA: "cerimonia" e "buque"
       sao o que a pessoa digita, e nenhum dos dois esta no nome das pecas.
       A busca ignora `cat`: termo e categoria juntos devolveriam quase sempre
       vazio, e quem digita ja disse o que quer. */
    var termo = (param('q') || '').trim();
    var busca = null;
    if (termo) {
      busca = chave(termo);
      cat = null;
      itens = E.PRODUTOS.filter(function (p) {
        var c = categoria(p.cat);
        return chave(p.nome + ' ' + (p.resumo || '') + ' ' + (c ? c.nome : '')).indexOf(busca) !== -1;
      });
      colecao = null;
    }

    /* Colecao sem nenhum SKU reconhecido pelo catalogo do app.js: fica a lista
       que o servidor ja escreveu (links /products/), em vez de grade vazia. */
    if (colecao && !itens.length) return;

    var pele = cat ? cat.registro : 'institucional';
    document.body.setAttribute('data-pele', pele);

    var titulo = $('[data-titulo]');
    if (titulo) titulo.textContent = busca ? ('Busca: ' + termo)
      : (colecao && colecao.titulo ? colecao.titulo : (cat ? cat.nome : 'Todas as peças'));

    var sub = $('[data-sub]');
    if (sub) {
      if (busca) {
        var n = itens.length;
        sub.textContent = n === 0
          ? 'Nenhuma peça com esse termo. O catálogo inteiro está logo abaixo.'
          : (n === 1 ? 'Uma peça encontrada.' : n + ' peças encontradas.');
      } else {
        sub.textContent = pele === 'cerimonia'
          ? 'Coroas de Flores e Arranjos Fúnebres. Entregamos em Brasília e no entorno.'
          : 'Cada peça é montada na hora, com o que chegou bom no mercado naquela manhã.';
      }
    }

    var mig = $('[data-migalha]');
    if (mig) {
      mig.innerHTML = '<a href="/">Início</a> › <a href="/collections/all">Catálogo</a>' +
                      (busca ? ' › <span>' + termo.replace(/</g, '&lt;') + '</span>'
                             : (colecao && colecao.titulo ? ' › <span>' + colecao.titulo + '</span>'
                             : (cat ? ' › <span>' + cat.nome + '</span>' : '')));
    }

    /* Busca sem resultado nao pode devolver grade vazia: cai no catalogo inteiro,
       que e o que a pessoa faria em seguida de qualquer jeito. */
    if (busca && !itens.length) {
      itens = E.PRODUTOS;
      busca = null;
    }

    /* MESMO markup do itemLista no app.js. Os dois tinham divergido — a home
       já era coluna e a PLP ainda era linha, com <p> dentro de <a> por cima.
       Mexeu num, mexa no outro. */
    function linhaCerimonia(p) {
      return '<a class="lista__i" href="' + edwHref(p.id) + '">' +
        /* SEGUNDA FOTO na pele Cerimonia. Mesma tecnica do card (empilhar e
           revelar por opacidade), mas SEM o scale do .pcard: o deck proibe
           movimento aqui. So a troca, em silencio. */
        '<span class="lista__fig' + (p.img2 ? ' lista__fig--dupla' : '') + '">' +
          '<img src="' + p.img + '" alt="' + p.nome + '" loading="lazy">' +
          (p.img2 ? '<img class="lista__zoom" src="' + p.img2 +
                    '" alt="" aria-hidden="true" loading="lazy">' : '') +
        '</span>' +
        '<span class="lista__n">' + p.nome + '</span>' +
        '<span class="lista__d">' + (p.resumo || '') + '</span>' +
        '<span class="lista__p">' + (E.temPreco(p) ? money(p.preco) : 'Sob consulta') + '</span>' +
      '</a>';
    }

    if (pele === 'cerimonia') {
      alvo.className = 'lista';
      alvo.innerHTML = itens.map(linhaCerimonia).join('');
    } else {
      /* Na listagem SEM categoria, as peças de cerimônia NÃO podem entrar
         na mesma grade festiva dos buquês — o deck proíbe card, selo e
         nota nesse registro. Elas saem da grade e ganham um bloco próprio,
         em lista, com a pele correta. */
      var itensBusca = itens.slice();
      if (!cat) {
        itens = itens.filter(function (p) { return p.registro !== 'cerimonia'; });
      }
      alvo.className = 'product-grid';
      alvo.innerHTML = itens.map(function (p) {
        var selos = (p.selos || []).map(function (s) {
          if (s === 'promo') {
            var pct = p.de ? Math.round((1 - p.preco / p.de) * 100) : 0;
            return '<span class="badge badge--promo">-' + pct + '%</span>';
          }
          if (s === 'novo') return '<span class="badge badge--novo">Novo</span>';
          if (s === 'top')  return '<span class="badge badge--top">Mais pedido</span>';
          return '';
        }).join('');
        var c = categoria(p.cat);

        /* SEGUNDA FOTO NO HOVER (`img2`).
           ATENÇÃO: este card é uma SEGUNDA implementação — a primeira é
           `cardProduto()` em app.js (~linha 502), usada nos destaques da home.
           A grade da PLP passa por AQUI. Quando o hover foi escrito, só o
           app.js recebeu, e a listagem inteira ficou sem o efeito: 56 cards
           com `dupla=0`. Mexeu numa, mexa na outra — ou junte as duas.
           A segunda <img> é decorativa: alt vazio e aria-hidden, senão o
           leitor de tela lê o nome do produto duas vezes por card. */
        var zoom = p.img2
          ? '<img class="pcard__zoom" src="' + p.img2 + '" alt="" aria-hidden="true" loading="lazy">'
          : '';

        return '<article class="pcard">' +
          '<a class="pcard__fig' + (p.img2 ? ' pcard__fig--dupla' : '') +
             '" href="' + edwHref(p.id) + '">' +
            '<img src="' + p.img + '" alt="' + p.nome + '" loading="lazy">' +
            zoom +
            (selos ? '<span class="pcard__badges">' + selos + '</span>' : '') +
          '</a>' +
          '<span class="pcard__cat">' + (c ? c.nome : '') + '</span>' +
          '<h3 class="pcard__n"><a href="' + edwHref(p.id) + '">' + p.nome + '</a></h3>' +
          (p.nota ? '<span class="pcard__nota"><i data-lucide="star"></i>' + p.nota +
                    ' <span>(' + p.avaliacoes + ')</span></span>' : '') +
          '<span class="pcard__precos">' +
            (E.temPreco(p)
              ? (p.de ? '<span class="pcard__de">' + money(p.de) + '</span>' : '') +
                '<span class="pcard__por">' + money(p.preco) + '</span>'
              : '<span class="pcard__por pcard__por--consulta">Sob consulta</span>') +
          '</span>' +
          '<p class="pcard__parc">' +
            (E.temPreco(p) ? E.PARCELAS + 'x de ' + money(p.preco / E.PARCELAS) + ' sem juros'
                           : 'Fechamos pelo WhatsApp') +
          '</p>' +
        '</article>';
      }).join('');

      /* Bloco separado de cerimônia, com a pele própria: uma tinta, sem
         card, sem selo. A separação é estrutural, não decorativa. */
      if (!cat) {
        var universo = (busca || colecao) ? itensBusca : E.PRODUTOS;
        var cerimonia = universo.filter(function (p) { return p.registro === 'cerimonia'; });
        if (cerimonia.length) {
          var bloco = document.createElement('section');
          bloco.setAttribute('data-pele', 'cerimonia');
          bloco.style.marginTop = '3.5rem';
          bloco.innerHTML =
            '<div class="section__head" style="text-align:left;margin-inline:0;max-width:none">' +
              '<div class="section__eyebrow">Registro</div>' +
        '<h2 class="section__title">Coroas de Flores</h2>' +
              '<p class="section__text">Coroas de Flores e Arranjos Fúnebres. Entregamos em Brasília e no entorno.</p>' +
            '</div>' +
            '<div class="lista">' + cerimonia.map(linhaCerimonia).join('') + '</div>';
          alvo.parentNode.insertBefore(bloco, alvo.nextSibling);
        }
      }
    }
    montarSobre(cat, busca);
    icones();
  }


  /* ---------------------------------------------------------------
     O EDITORIAL DE FIM DE PAGINA DA CATEGORIA  (31/08/2026, pedido do Erik)

     Pedido: "cada categoria no fim da pagina tem informacoes sobre" — a
     estrutura vem de dois prints da Reserva Floral (colecao Buques e colecao
     Orquideas). O que veio de la e a ARQUITETURA: duas colunas no pe da
     listagem, uma editorial ("Sobre nossos X") e uma de consulta rapida
     ("Como cuidar"), com rotulo em caixa-alta a esquerda de cada item.

     SEIS COISAS QUE NAO SE ADIVINHA LENDO O CODIGO:

     1. NENHUMA FRASE E REDACAO NOVA SOBRE A LOJA. Todo fato aqui ja esta
        publicado em outro lugar do site, e a fonte e sempre a mesma: os
        acordeoes da PDP (`acordeoes()`, mais abaixo neste arquivo) e a FAQ da
        home. "Parecida com a foto, nunca identica", "troque a agua a cada dois
        dias", "espuma saturada, vinte e quatro a trinta e seis horas", "a faixa
        acompanha, caixa-alta, uma linha, sem adjetivo" — todas de la. Se um dia
        divergirem, **a FAQ da home continua sendo a fonte**, como o comentario
        dos acordeoes ja manda. O que e conhecimento de floricultura (o etileno
        da fruta madura, a casca em vez de terra na Phalaenopsis) esta dito como
        botanica, nunca como promessa da casa.

     2. O BLOCO SO EXISTE COM CATEGORIA NA URL. Sem `?cat=`, a PLP e o catalogo
        inteiro e nao ha "o item da categoria selecionada" sobre o que falar; em
        busca (`?q=`) o resultado atravessa categorias. Nos dois casos
        `montarSobre` sai sem escrever nada.

     3. O LINK DO WHATSAPP E ESCRITO AQUI, COM `href` PRONTO. O `[data-whatsapp]`
        do app.js e varrido UMA vez, no `DOMContentLoaded`, e o app.js roda ANTES
        do pagina.js — quando a varredura acontece este bloco ainda nao existe no
        DOM. Marcar o botao com `data-whatsapp` o deixaria com href vazio.

     4. NAO LEVA `data-reveal`. O IntersectionObserver tambem e armado uma vez, no
        carregamento; elemento inserido depois nunca e observado e ficaria preso
        em `opacity:0` — a secao inteira sumiria sem erro nenhum no console.

     5. A COLUNA DA DIREITA MUDA DE NOME NA PELE CERIMONIA. Ali ela nao e
        "Como cuidar" (a peca dura o velorio; nao ha o que cuidar) e sim o que a
        casa ja resolve: faixa, entrega e duracao. Pela mesma regra do §5.2 dos
        tokens, todo item desse registro e afirmacao e nunca pergunta, e nao ha
        um ponto de exclamacao em nenhuma string deste objeto.

     6. TODA FOTO SAIU DO CATALOGO — nenhuma geracao entrou aqui. Sao 17: uma de
        abertura por categoria e uma por etapa. E DUAS CAPAS DE CATEGORIA FORAM
        RECUSADAS de proposito, as duas pelo mesmo motivo — TAMANHO:
        · `cat-cestas.jpg` traz a etiqueta do laco com MARCA INVENTADA pelo
          gerador (ressalva ja registrada no §6d do brief 18). No card de 277px
          ela e ilegivel; aqui a foto abre com 548px e o texto falso fica legivel,
          o que e marca de terceiro na pagina. Entrou `//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__mao-2037.jpg?v=140191780352995593541787764297`,
          que e a MESMA peca sem a etiqueta.
        · `cat-orquideas.jpg` mostra um ANTURIO, nao uma orquidea — a foto foi
          escolhida para a gaveta 'Orquideas & Plantas' por ser planta, e serve
          como capa; ao lado de um texto que fala de Phalaenopsis, de raiz e de
          casca, ela desmente a legenda. Entrou `//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__mao-2035.jpg?v=107018061506357999781787593381`, que e a
          Orquidea Branca do catalogo real, inteira no cachepo.
        **Regua: foto aprovada em card de 277px nao esta aprovada para 548px.**

     7. O TEXTO FOI CORTADO A 1/3 (31/08/2026, pedido do Erik: "nao deixe com
        muito texto, so um pouco"). Cada categoria saiu de ~235 para ~79 palavras.
        O que saiu foi o PARAGRAFO DO MEIO — o `corpo`, que explicava o que o
        lede ja afirma — e a segunda frase de cada etapa, que era a razao da
        primeira. **O que sobrou de cada etapa e UMA instrucao, sem o porque.**
        Quem for devolver explicacao aqui: o lugar dela e o acordeao da PDP, que
        ja carrega o texto longo e e a fonte de tudo que este bloco resume.

     8. CADA ETAPA GANHOU FOTO, E ISSO E O QUE MUDOU A SECAO DE CATEGORIA. Duas
        armadilhas do lote:
        · **A escolha e por HONESTIDADE, nao por beleza.** `hero-home-clean-c.jpg`
          entrou em "Embrulho" porque mostra o papel kraft sendo fechado, e
          `zoom-2033.jpg` entrou em "Agua" porque e o vaso de vidro limpo. Foto
          que nao mostra o que o rotulo diz repete o erro do anturio do item 6.
        · **Onde a etapa nao tinha foto honesta, a ETAPA mudou — nunca a foto.**
          Em Plantas, "Agua" virou "Casca" (a foto que existe e a do cachepo
          trancado) e "Repouso" virou "A proxima flor". Em Coroas, "A duracao"
          virou "A peca", com o prazo dentro da frase. O fato sobreviveu; o
          recorte e que mudou.
     --------------------------------------------------------------- */
  var SOBRE = {
    buques: {
      olho: 'Há mais de 35 anos no Mercado das Flores',
      titulo: 'Sobre nossos buquês',
      lede: 'Montado na hora, haste por haste, com a flor que chegou boa no mercado naquela manhã.',
      fecho: 'Parecido com a foto, nunca idêntico — o que não muda é o porte e a paleta.',
      marca: 'o que não muda é o porte e a paleta.',
      foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cat-buques-humanizada.png?v=135138240929514349141787594457', fw: 1122, fh: 1402,
      alt: 'Buquê recém-montado na banca, segurado pela florista',
      cta: 'Falar com a Edelweiss',
      msg: 'Ola, vim pela pagina de Buques do site.',
      rotulo: 'Como cuidar',
      itens: [
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__buque-corte.jpg?v=124144345565663861001788193622',
          alt: 'A tesoura cortando o talo na diagonal, com dois já cortados ao lado',
          r: 'Corte', d: 'Um dedo do talo na diagonal a cada troca de água. Amassado, o talo fecha e a flor para de beber.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__buque-agua.jpg?v=19374714018711711291788193042',
          alt: 'A mão segurando o vaso de vidro lavado contra a janela',
          r: 'Água', d: 'Trocada a cada dois dias, lavando o vaso na troca. Folha submersa apodrece antes da flor e suja a água.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__buque-lugar.jpg?v=170204696384789353631788193042',
          alt: 'Buquê no vaso, na sombra, com a mancha de sol parando na parede',
          r: 'Lugar', d: 'Longe do sol direto, do ar-condicionado e de fruta madura. A fruta solta etileno, e o etileno abre a flor antes da hora.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__buque-embrulho.jpg?v=115626869306265543501788193042',
          alt: 'O papel kraft aberto na bancada, com o buquê recém-tirado dele',
          r: 'Embrulho', d: 'Fora do papel e dentro do vaso no mesmo dia. Buquê em celofane dura mais depois que sai do embrulho.' }
      ]
    },

    cestas: {
      olho: 'Há mais de 35 anos no Mercado das Flores',
      titulo: 'Sobre nossas cestas e presentes',
      lede: 'A flor é montada na hora; o chocolate, o vinho e a pelúcia chegam lacrados.',
      fecho: 'O acompanhamento faz parte da peça: quando falta, a loja chama antes de montar.',
      marca: 'a loja chama antes de montar.',
      foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__mao-2037.jpg?v=140191780352995593541787764297', fw: 1200, fh: 1500,
      alt: 'Cesta de flores do campo sustentada pela base, na banca',
      cta: 'Falar com a Edelweiss',
      msg: 'Ola, vim pela pagina de Cestas e Presentes do site.',
      rotulo: 'Como cuidar',
      itens: [
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__cesta-flores.jpg?v=162864514895592325531788199387',
          alt: 'A cesta de flores do campo na bancada, contra a janela',
          r: 'Flores', d: 'Longe do sol e do ar-condicionado, com água a cada dois dias. São a única parte viva da cesta.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__cesta-chocolate.jpg?v=92630201902785333271788200387',
          alt: 'A caixa de bombons aberta na bancada, meia no sol e meia na sombra',
          r: 'Chocolate', d: 'Lugar fresco e seco, fora da geladeira e do carro parado. Na geladeira o bombom embranquece; no carro, derrete.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__cesta-vinho.jpg?v=55887464364561027691788199387',
          alt: 'A garrafa deitada no peitoril, com o rótulo virado para longe',
          r: 'Vinho', d: 'Deitado e ao abrigo da luz enquanto não for aberto. Deitada, a rolha fica úmida e não deixa passar ar.' }
      ]
    },

    plantas: {
      olho: 'Há mais de 35 anos no Mercado das Flores',
      titulo: 'Sobre nossas orquídeas e plantas',
      lede: 'A orquídea sai daqui com raiz e substrato: é planta viva, não composição montada.',
      fecho: 'Depois que a última flor cai, ela continua sua — e volta a florir.',
      marca: 'e volta a florir.',
      foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__mao-2035.jpg?v=107018061506357999781787593381', fw: 1200, fh: 1500,
      alt: 'Orquídea Phalaenopsis inteira no cachepô, sustentada pela base',
      cta: 'Falar com a Edelweiss',
      msg: 'Ola, vim pela pagina de Orquideas e Plantas do site.',
      rotulo: 'Como cuidar',
      itens: [
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__planta-luz.jpg?v=5113963964573316181788193041',
          alt: 'Duas folhas de orquídea contra a janela, de perfil',
          r: 'Luz', d: 'Clara e indireta, longe da janela que pega sol da tarde. Sol direto na folha queima, e a mancha não sai mais.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__planta-cachepo.jpg?v=14961704592381345881788193042',
          alt: 'A mão apoiada na borda do cachepô, com a casca à mostra',
          r: 'O cachepô', d: 'Vai em casca, não em terra: a água atravessa e escorre. Raiz de orquídea parada na água apodrece.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__planta-proxima-flor.jpg?v=149147902387171057781788193041',
          alt: 'A haste velha seca sobre as folhas da orquídea, depois da florada',
          r: 'A próxima flor', d: 'A haste seca e a planta descansa. A próxima florada vem quando as noites esfriam, algumas semanas depois.' }
      ]
    },

    cerimonia: {
      olho: 'Ao lado do Campo da Esperança da Asa Sul',
      titulo: 'Sobre nossas coroas',
      lede: 'Montada na banca, sobre espuma saturada de água, e sai daqui com a faixa já impressa.',
      fecho: 'O porte e a paleta são os da foto; a flor é a que chegou boa naquela manhã.',
      foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cer-coroa-rosas-brancas.jpg?v=109204795168639589481788268395', fw: 900, fh: 900,
      alt: 'Coroa de rosas brancas sobre o cavalete, de frente',
      cta: 'Falar com a Edelweiss',
      msg: 'Ola, vim pela pagina de Coroas de Flores do site.',
      rotulo: 'O que já está resolvido',
      itens: [
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cuidado__coroa-faixa.jpg?v=36181634945321727911788268395',
          alt: 'A faixa branca atravessando a coroa de flores brancas',
          r: 'A faixa', d: 'Acompanha a peça, sem custo. O nome sai em caixa-alta, em uma linha, sem adjetivo. Se preferir, a loja sugere a redação.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-coroa-cavalete.jpg?v=72987427078567521231788268395',
          alt: 'Coroa montada sobre o cavalete, diante da parede de azulejo',
          r: 'A entrega', d: 'Capela, cemitério ou residência no Distrito Federal, com hora marcada. A peça chega antes do início da cerimônia.' },
        { foto: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cer-coroa-campo.jpg?v=132198249509934606231788268395',
          alt: 'Coroa de flores do campo sobre o cavalete',
          r: 'A peça', d: 'Coroa ou arranjo, sobre espuma saturada de água. Mantém-se de vinte e quatro a trinta e seis horas — o velório e o sepultamento.' }
      ]
    }
  };

  function montarSobre(cat, busca) {
    if (!cat || busca) return;
    var s = SOBRE[cat.id];
    if (!s) return;
    var raiz = document.getElementById('main');
    if (!raiz) return;

    /* A FAIXA DE CUIDADO É ILUSTRADA OU NÃO É — nunca pela metade.
       Uma fileira com foto em dois itens e nada no terceiro não lê como "falta
       uma foto", lê como componente quebrado: os rótulos desalinham e o item
       sem foto parece um erro de carregamento. Então o gatilho é `every`: basta
       um item sem `foto` para a categoria inteira voltar ao formato de texto.
       Consequência prática — ao acrescentar a última foto que faltava numa
       categoria, a fileira dela muda de formato sozinha. */
    var ilustrada = s.itens.every(function (i) { return !!i.foto; });

    /* A FRASE MARCADA sai do fecho por `indexOf`, e nao e redacao nova.
       A referencia grifa UMA frase do paragrafo de corpo, e a regra n.o 1
       deste bloco continua valendo: nada aqui e escrito para a marca. Entao
       `marca` nao carrega texto — carrega um PEDACO EXATO do `fecho`, e o
       destaque so acontece se ele for encontrado ali. Divergiu, degrada para
       texto liso: nunca duplica a frase nem quebra a marcacao.
       CERIMONIA NAO TEM `marca` de proposito — ver comentario 9. */
    var fecho = s.fecho;
    if (s.marca && fecho.indexOf(s.marca) !== -1) {
      fecho = fecho.replace(s.marca,
        '<mark class="sobre-cat__marca">' + s.marca + '</mark>');
    }

    /* O ROTULO E O TEXTO VAO NUM INVOLUCRO, e ele nao e decoracao de CSS.
       Pedido do Erik em 31/08: "coloque os textinhos embaixo dos subtitulos".
       Com os tres soltos, a linha era uma grade de TRES colunas e o rotulo
       ficava numa faixa propria de 7,5rem quase vazia — era ela que abria o
       vao que ele viu. Empilhados, a linha vira DUAS colunas: um bloco de
       texto e a foto ao lado.
       O involucro tem de existir no DOM: com rotulo e texto como filhos
       diretos, uma foto que atravessa as duas linhas nao consegue impor
       altura a elas (ela recebe a area, nao a define) e transborda por cima
       do filete. Com o bloco, a linha volta a ser um par de dois itens e o
       `align-items:center` resolve os dois de uma vez.
       No celular a foto volta para a esquerda por colocacao explicita. */
    var itens = s.itens.map(function (i) {
      return '<li class="cuidado__i">' +
               '<div class="cuidado__txt">' +
                 '<h4 class="cuidado__r">' + i.r + '</h4>' +
                 '<p class="cuidado__d">' + i.d + '</p>' +
               '</div>' +
               (ilustrada
                 ? '<figure class="cuidado__fig"><img src="' + i.foto +
                   '" alt="' + (i.alt || '') + '" loading="lazy"></figure>'
                 : '') +
             '</li>';
    }).join('');

    var sec = document.createElement('section');
    sec.className = 'section section--fundo sobre-cat';
    sec.setAttribute('aria-labelledby', 'sobre-cat-t');
    sec.innerHTML =
      '<div class="container">' +

        /* DUAS COLUNAS, e as duas correm a altura inteira do par: o editorial
           a esquerda (olho, titulo, lede, fecho, FOTO, botao) e a consulta a
           direita (rotulo + linhas). E a arquitetura das duas referencias.
           O que a faz fechar o pe sem vao morto esta no CSS: a foto do
           editorial e o unico elemento elastico do par. */
        '<div class="sobre-cat__par">' +

          '<div class="sobre-cat__txt">' +
            '<p class="section__eyebrow sobre-cat__olho">' + s.olho + '</p>' +
            '<h2 class="section__title" id="sobre-cat-t">' + s.titulo + '</h2>' +
            '<p class="sobre-cat__lede">' + s.lede + '</p>' +
            '<p class="sobre-cat__p">' + fecho + '</p>' +
            '<figure class="sobre-cat__fig">' +
              '<img src="' + s.foto + '" alt="' + s.alt + '" width="' + s.fw +
              '" height="' + s.fh + '" loading="lazy">' +
            '</figure>' +
            '<a class="btn btn--primaria sobre-cat__btn" target="_blank" rel="noopener" href="https://wa.me/' +
              E.WHATSAPP + '?text=' + encodeURIComponent(s.msg) + '">' + s.cta + '</a>' +
          '</div>' +

          '<div class="sobre-cat__faixa">' +
            '<h3 class="sobre-cat__rotulo">' + s.rotulo + '</h3>' +
            '<ul class="cuidado">' + itens + '</ul>' +
          '</div>' +

        '</div>' +

      '</div>';

    raiz.appendChild(sec);
  }

  /* ---------------------------------------------------------------
     PDP — página de produto

     A ESTRUTURA segue a referência aprovada em 17/08/2026: coluna
     ESQUERDA com galeria, tira da loja e fichas de prova; coluna DIREITA
     com preço, entrega, compra, bilhete, acompanhamentos, garantias e
     acordeões — nesta ordem, que é a ordem das perguntas de quem compra
     flor à distância e não vai ver a peça antes.

     A pele CERIMÔNIA corta o que o §5 do deck proíbe: carrossel de
     acompanhamento, selo, nota, badge, caixa com sombra. Não é uma versão
     "reduzida por falta de conteúdo" — é o mesmo esqueleto sem os
     ornamentos que aquele registro não admite. Duas diferenças que não se
     adivinham: a galeria fica com UMA foto (as de contexto têm cor, gente
     e movimento) e o campo da faixa vem ANTES do botão, porque ali ele é
     dado do pedido, não um extra que se acrescenta depois.
     --------------------------------------------------------------- */

  /* Fotos de CONTEXTO da galeria. O protótipo tem UMA foto por peça, e
     preencher a galeria com a foto de outro produto é exatamente o erro que
     o catálogo já registra em app.js (nome e imagem discordando é erro que
     o cliente enxerga). Então o segundo e o terceiro slide não se fingem de
     peça: entram ROTULADOS pelo que são, e a legenda aparece sobre a foto.
     Quando a loja mandar as fotos de verdade, basta pôr `imgs: [...]` no
     produto — o contexto sai de cena sozinho.
     `pos` existe porque a foto da bancada é 16:9 com o assunto no terço
     direito: recortada em 4:5 sem object-position, o buquê fica de fora. */
  var CONTEXTO = [
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-laco-sisal.jpg?v=39337746835057546401787593380',        papel: 'O laço de sisal, amarrado à mão na banca' },
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-hero-home-clean-a.jpg?v=153143790560272858631787593380', papel: 'A bancada, na parede de azulejo da banca',
      pos: 'right center' }
  ];

  function fotosDe(p, cerimonia) {
    if (p.imgs && p.imgs.length) {
      return p.imgs.map(function (src) { return { src: src, papel: '' }; });
    }
    var fotos = [{ src: p.img, papel: '' }];
    /* `img2` é o CLOSE NAS FLORES da própria peça — a mesma foto que troca no
       hover do card. Sendo foto do produto, ela substitui o contexto em vez de
       se somar a ele: é o caso que o comentário acima previa. Sem `papel`,
       porque rótulo aqui diria ao cliente que a foto não é da peça, e é. */
    if (p.img2) return fotos.concat([{ src: p.img2, papel: '' }]);
    if (!cerimonia) {
      /* Compara com p.img porque três produtos usam como foto principal
         justamente uma das fotos de contexto — sem isto, a peça apareceria
         duas vezes na mesma galeria. */
      CONTEXTO.forEach(function (c) { if (c.src !== p.img) fotos.push(c); });
    }
    return fotos;
  }

  function galeria(p, fotos) {
    var muitas = fotos.length > 1;
    var thumbs = !muitas ? '' :
      '<div class="gal__thumbs">' + fotos.map(function (f, i) {
        return '<button class="gal__thumb" type="button" data-ir="' + i + '"' +
            (i === 0 ? ' aria-current="true"' : '') +
            ' aria-label="Ver foto ' + (i + 1) + ' de ' + fotos.length + '">' +
          '<img src="' + f.src + '" alt=""' +
            (f.pos ? ' style="object-position:' + f.pos + '"' : '') + '>' +
        '</button>';
      }).join('') + '</div>';

    /* `gal--so` NÃO é enfeite: sem ela a grade de duas faixas continua valendo
       com uma foto só, e o palco cai na faixa de 74px das miniaturas — a foto
       da peça vira uma miniatura e a página parece quebrada. É o caso normal
       da pele cerimônia, que não recebe fotos de contexto. */
    return '<div class="gal' + (muitas ? '' : ' gal--so') + '">' + thumbs +
      '<div class="gal__palco">' +
        '<img class="gal__foto" src="' + fotos[0].src + '" alt="' + p.nome + '">' +
        (muitas ? '<span class="gal__conta" data-conta-foto>1/' + fotos.length + '</span>' : '') +
        '<button class="gal__share" type="button" data-share ' +
          'aria-label="Copiar o link desta peça"><i data-lucide="share-2"></i></button>' +
        '<span class="gal__papel" data-papel hidden></span>' +
      '</div>' +
    '</div>';
  }

  /* TIRA DA LOJA — o "atelier em movimento" da referência é feito de dois
     vídeos. Aqui é foto: vídeo da banca ainda não existe, e é por isso que
     VIDEO_LOJA continua vazio no app.js. A estrutura é a mesma — duas peças
     verticais, numeradas, legenda embaixo —, então trocar por <video> no dia
     que houver arquivo é mexer só nesta função. */
  var TIRA = [
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-mercado-banca.jpg?v=107323727776239302931787593381', n: '01', t: 'Na banca',
      alt: 'Banca da Floricultura Edelweiss no Mercado das Flores, com parede de azulejos e baldes galvanizados' },
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-loja-video-poster.jpg?v=13715466415089018811787593381', n: '02', t: 'Na loja',
      alt: 'Fachada da Floricultura Edelweiss no fim da tarde, com orquídeas na vitrine' }
  ];

  /* A CERIMÔNIA GANHOU TIRA PRÓPRIA em 17/08/2026, e ela não é enfeite de
     simetria. Sem tira, aquela coluna tinha só a foto e os quatro tópicos e
     media 233px menos que a coluna de compra. As duas fotos escolhidas são as
     que respondem às duas dúvidas materiais de quem encomenda coroa por
     telefone: como a peça fica de pé, e como a faixa com o nome aparece.
     Elas cumprem o §6 dos tokens para este registro — sem gente, sem cor
     festiva, luz de janela, parede clara. E grade de duas fotos não é
     carrossel nem card, que é o que o §5 do deck proíbe aqui. */
  var TIRA_CERIMONIA = [
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-coroa-cavalete.jpg?v=72987427078567521231788268395', n: '01', t: 'Sobre o cavalete',
      alt: 'Coroa de crisântemos brancos sobre cavalete de madeira, diante da parede de azulejo' },
    { src: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-coroa-detalhe.jpg?v=119556514850603276301788269029', n: '02', t: 'A faixa com o nome',
      alt: 'Detalhe da coroa branca com a fita de cetim onde o nome é impresso' }
  ];

  function tira(cerimonia) {
    var itens = cerimonia ? TIRA_CERIMONIA : TIRA;
    return '<section class="tira">' +
      '<h2 class="tira__t">' +
        (cerimonia ? 'Como a peça chega.' : 'Onde a peça é montada.') + '</h2>' +
      '<div class="tira__grade">' + itens.map(function (i) {
        return '<figure class="tira__i">' +
          '<img src="' + i.src + '" alt="' + i.alt + '" loading="lazy">' +
          '<figcaption class="tira__cap"><span class="tira__n">' + i.n + '</span>' +
            i.t + '</figcaption>' +
        '</figure>';
      }).join('') + '</div>' +
    '</section>';
  }

  /* FICHAS DE PROVA. A nota do Google vem do objeto exportado pelo app.js,
     não copiada para cá: quando a loja passar de 11 avaliações, a home e a
     PDP mudam juntas. Se `ligado` virar false ou `de` virar 0, a linha some
     — a mesma regra do selo da home.
     A nota fica FORA da pele cerimônia por regra do deck (sem nota, sem
     selo naquele registro), e não por decoro. */
  function fichas(cerimonia) {
    var itens = [];
    var g = E.GOOGLE;
    if (!cerimonia && g && g.ligado && g.de) {
      itens.push({ icone: 'star', url: g.url, t: g.nota + ' no Google',
        d: g.de + ' avaliações' + (g.todasCinco ? ' · todas de cinco estrelas' : '') });
    }
    itens.push({ icone: 'store', t: 'Mercado das Flores, Loja 13',
      d: 'SHLS 716 · Asa Sul · Brasília' });
    itens.push({ icone: 'message-circle', t: 'Pedido acompanhado por WhatsApp',
      d: 'A loja manda a foto da peça antes de sair para a entrega' });
    /* A terceira ficha da cerimônia entrou pela MEDIÇÃO e ficou pelo conteúdo:
       sem a nota do Google e sem a tira de fotos, a coluna da esquerda ficava
       130px mais curta que a de compra. E a informação que faltava ali é
       justamente esta — quem encomenda coroa às vezes encomenda de madrugada.
       O texto é o da FAQ da home e não promete plantão: manda confirmar. */
    if (cerimonia) {
      itens.push({ icone: 'phone', t: 'Fora do horário comercial',
        d: 'Velório não escolhe hora. Ligue e confirme o atendimento no horário em que você precisa' });
    }

    /* O prefixo `pdp-prova` não é capricho: `.ficha` e `.ficha__d` JÁ EXISTEM
       no styles.css, na ficha de flores da página de eventos, e lá `.ficha` é
       `display:flex;flex-direction:column`. Com o nome curto, a regra de
       eventos (que vem depois no arquivo) empilhava ícone e texto aqui, e o
       bloco lia como uma lista quebrada. */
    return '<div class="pdp-provas">' + itens.map(function (f) {
      var dentro = '<i data-lucide="' + f.icone + '"></i>' +
        '<span class="pdp-prova__txt"><span class="pdp-prova__t">' + f.t + '</span>' +
        '<span class="pdp-prova__d">' + f.d + '</span></span>';
      return f.url
        ? '<a class="pdp-prova" href="' + f.url + '" target="_blank" rel="noopener">' +
            dentro + '<i class="pdp-prova__ir" data-lucide="arrow-up-right"></i></a>'
        : '<div class="pdp-prova">' + dentro + '</div>';
    }).join('') + '</div>';
  }

  /* ACOMPANHAMENTOS — o "adicione um mimo" da referência. Aqui NÃO pode
     chamar mimo: `.mimos` na home já é a faixa de benefícios sob o hero, e
     a mesma palavra em duas coisas diferentes engana quem for editar.
     São peças REAIS do catálogo — as três mais baratas do registro presente
     —, não um cadastro paralelo de brinde que ninguém mantém. */
  function junto(p) {
    /* O filtro por FOTO REPETIDA é obrigatório enquanto o catálogo do
       protótipo reusa a mesma imagem em produtos diferentes: o coração de
       rosas e o arranjo de mesa compartilham `laco-sisal.jpg`, e a fileira
       saía com dois cartões visualmente idênticos e preços
       diferentes — que lê como erro de site, não como duas peças.
       (Até 17/08/2026 o par citado aqui era suculentas + girassóis, em
       `mercado-banca.jpg`; as suculentas saíram com a categoria `plantas`.
       O filtro continua valendo — só mudou qual par ele pega.)
       A ordenação vem ANTES da deduplicação: invertido, sobreviveria o
       primeiro do array e não o mais barato do par. */
    var vistas = {};
    vistas[p.img] = true;
    var itens = E.PRODUTOS.filter(function (o) {
      return o.registro === 'presente' && o.id !== p.id;
    }).sort(function (a, b) { return a.preco - b.preco; })
      .filter(function (o) {
        if (vistas[o.img]) return false;
        vistas[o.img] = true;
        return true;
      }).slice(0, 3);
    if (!itens.length) return '';

    return '<section class="junto">' +
      '<h2 class="junto__t">Levar junto?</h2>' +
      '<div class="junto__trilho">' + itens.map(function (o) {
        return '<label class="junto__i">' +
          '<img src="' + o.img + '" alt="' + o.nome + '" loading="lazy">' +
          '<span class="junto__marca"><input type="checkbox" data-junto="' + o.id + '">' +
            '<span>Levar</span></span>' +
          '<span class="junto__n">' + o.nome + '</span>' +
          '<span class="junto__p">+ ' + money(o.preco) + '</span>' +
        '</label>';
      }).join('') + '</div>' +
    '</section>';
  }

  /* Os três fatos do registro presente são os MESMOS da faixa da home, de
     propósito: garantia que troca de texto entre páginas lê como promessa
     nova, e promessa nova pede prova nova. */
  function garantias(cerimonia) {
    var itens = cerimonia
      ? [{ i: 'clock',    t: 'Entrega com hora marcada no Distrito Federal' },
         { i: 'volume-x', t: 'A equipe não se identifica em voz alta no local' },
         { i: 'ribbon',   t: 'Faixa com o nome, sem custo' }]
      : [{ i: 'truck',    t: 'Entrega no Plano Piloto no mesmo dia, até as 14h' },
         { i: 'flower-2', t: 'Montado na hora, com a flor do dia' },
         { i: 'pen-line', t: 'Bilhete escrito à mão' }];
    return '<ul class="garantias">' + itens.map(function (g) {
      return '<li><i data-lucide="' + g.i + '"></i><span>' + g.t + '</span></li>';
    }).join('') + '</ul>';
  }

  /* ACORDEÕES. Os textos são os que já estão publicados na FAQ da home e no
     editorial da banca — não é redação nova. Repetir aqui é de propósito:
     quem entra por anúncio direto na peça nunca passou pela home, e a
     resposta tem que estar onde a dúvida acontece. Se um dia divergirem,
     a FAQ da home é a fonte. */
  function acordeoes(p, cerimonia) {
    var blocos = cerimonia ? [
      /* O resumo NÃO entra aqui: ele já está sob o preço, e repetir a mesma
         frase a dois cliques de distância faz o acordeão parecer vazio. */
      { t: 'Sobre a peça', c:
        '<p>A peça é montada na banca, com a flor que chegou boa naquela manhã. ' +
        'O porte e a paleta são os da foto; a composição acompanha o dia.</p>' },
      { t: 'A faixa e o que escrever nela', c:
        '<p>A faixa acompanha a peça, sem custo. O nome é impresso em caixa-alta, ' +
        'em uma linha, sem adjetivo.</p>' +
        '<p>Frases curtas funcionam melhor: de seis a doze palavras. O uso mais comum ' +
        'é o nome de quem envia, ou o vínculo — a família, os colegas de trabalho. ' +
        'Se preferir, a loja sugere a redação.</p>' },
      { t: 'Prazo e locais de entrega', c:
        '<p>Capelas, cemitérios, crematórios e residências no Distrito Federal, com ' +
        'hora marcada. A peça é programada para chegar antes do início da cerimônia.</p>' +
        '<p>Para o Campo da Esperança da Asa Sul, a loja fica ao lado do cemitério.</p>' },
      { t: 'Duração da peça', c:
        '<p>A coroa é montada sobre espuma saturada de água. Ela se mantém de vinte e ' +
        'quatro a trinta e seis horas, o que cobre o velório e o sepultamento.</p>' }
    ] : [
      { t: 'Descrição', c:
        '<p>Parecida com a foto, mas nunca idêntica — e isso faz parte do nosso jeito ' +
        'de criar. Nossos arranjos são montados com flores naturais selecionadas ' +
        'conforme a disponibilidade e a qualidade do dia. Por isso, alguns detalhes ' +
        'podem variar: a rosa pode estar mais aberta, o eucalipto mais prateado ou ' +
        'determinada flor apresentar uma tonalidade diferente. O que permanece é o ' +
        'porte, a proposta e a paleta de cores da composição, garantindo que o ' +
        'resultado mantenha a essência do produto apresentado.</p>' +
        '<p>E se alguma flor prevista não estiver com a qualidade ideal, entramos em ' +
        'contato antes da montagem. Nada é substituído por conta própria: você ' +
        'participa da escolha e aprova qualquer alteração.</p>' },
      { t: 'As flores e o cuidado', c:
        '<p>Troque a água a cada dois dias e corte um dedo do talo na diagonal a cada ' +
        'troca. Deixe longe do sol direto, do ar-condicionado e de fruta madura.</p>' +
        '<p>Buquê em celofane dura mais se sair do embrulho e entrar num vaso com água ' +
        'no mesmo dia. Planta em cachepô pede pouca água e luz indireta.</p>' },
      { t: 'Entrega e prazo', c:
        '<p>Entregamos em Brasília e região. No Plano Piloto, no mesmo dia, se o pedido ' +
        'entrar até as 14h.</p>' +
        '<p>Você diz a data e a faixa de horário, e a entrega é programada para ela. Fora ' +
        'do Plano Piloto o prazo e a taxa mudam conforme a distância — mande o endereço ' +
        'e a loja responde com o valor antes de você fechar.</p>' +
        '<p>Se não tiver ninguém para receber, a gente liga para você antes de voltar ' +
        'com a peça.</p>' },
      { t: 'A loja', c:
        '<p>Loja 13, no Mercado das Flores, SHLS 716, Asa Sul. Montagem própria, na ' +
        'banca, sem intermediário.</p>' +
        '<p>Dá para escolher na loja e levar na hora — é o melhor jeito de comprar aqui, ' +
        'porque você vê o que chegou naquela manhã.</p>' }
    ];

    /* UMA COLUNA, a pedido do Erik em 17/08/2026 — a versão anterior partia as
       quatro fichas em duas colunas e ele reprovou a divisão. Em coluna única o
       filete atravessa a página inteira e a lista lê de cima para baixo, na
       ordem em que as perguntas aparecem: o que é a peça, como cuidar, quando
       chega, quem monta. Só a PRIMEIRA nasce aberta; em duas colunas eram duas
       abertas, senão a da direita parecia desligada. Quem contribui com a
       largura de leitura é o `max-width` do `.faq__c`, não a coluna. */
    return '<section class="pdp__detalhes"><div class="faq__lista">' +
      blocos.map(function (b, i) {
        return '<details class="faq__i"' + (i === 0 ? ' open' : '') + '>' +
          '<summary><span>' + b.t + '</span>' +
          '<span class="faq__sinal" aria-hidden="true"></span></summary>' +
          '<div class="faq__c">' + b.c + '</div>' +
        '</details>';
      }).join('') +
    '</div></section>';
  }

  function semAcento(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^A-Za-z0-9 ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function montarPDP() {
    var alvo = $('[data-produto]');
    if (!alvo) return;

    /* /products/<handle> (product.liquid) manda o SKU em data-sku; /pages/produto manda ?id=.
       Peca fora do catalogo do app.js em /products/: sai sem mexer, fica o HTML de servidor. */
    var skuPagina = alvo.getAttribute('data-sku');
    var p = produto(param('id') || skuPagina);
    if (!p && skuPagina !== null) return;
    p = p || E.PRODUTOS[0];
    var cerimonia = p.registro === 'cerimonia';
    document.body.setAttribute('data-pele', p.registro);

    var cat = categoria(p.cat);
    var voltar = $('[data-voltar]');
    if (voltar) {
      voltar.setAttribute('href', edwCol(p.cat));
      voltar.setAttribute('aria-label', 'Voltar para ' + (cat ? cat.nome : 'o catálogo'));
    }
    var mig = $('[data-migalha]');
    if (mig) {
      mig.innerHTML = '<a href="/">Início</a> › ' +
        '<a href="' + edwCol(p.cat) + '">' + (cat ? cat.nome : 'Catálogo') + '</a> › <span>' + p.nome + '</span>';
    }
    document.title = p.nome + ' · Floricultura Edelweiss';

    /* BLOCO DE ENTREGA — a referência abre a coluna de compra por aqui, e faz
       sentido: data é a primeira decisão de quem manda flor, não a última.
       Presente pede dia e janela; cerimônia pede hora marcada e o endereço da
       capela. Os textos de cerimônia continuam sem acento como já estavam —
       não é descuido, é o registro da faixa. */
    var entrega = cerimonia
      ? '<div class="pdp__bloco">' +
          '<h2 class="pdp__rot">Quando e onde</h2>' +
          '<div class="dupla">' +
            '<div class="campo"><label class="campo__r" for="dia">Dia</label>' +
            '<input id="dia" type="date"></div>' +
            '<div class="campo"><label class="campo__r" for="hora">Hora marcada</label>' +
            '<input id="hora" type="time"></div>' +
          '</div>' +
          '<div class="campo"><label class="campo__r" for="local">Capela ou endereco</label>' +
          '<input id="local" placeholder="Capela 4 - Campo da Esperanca - Asa Sul"></div>' +
          '<p class="pdp__aviso">Se o local ainda nao foi definido, o pedido e registrado ' +
          'assim mesmo e o endereco entra depois.</p>' +
        '</div>'
      : '<div class="pdp__bloco">' +
          '<h2 class="pdp__rot">Data da entrega</h2>' +
          '<div class="dupla">' +
            '<div class="campo"><label class="campo__r" for="dia">Dia</label>' +
            '<input id="dia" type="date"></div>' +
            '<div class="campo"><label class="campo__r" for="janela">Janela</label>' +
            '<select id="janela"><option>Manhã · 9h às 12h</option>' +
            '<option>Tarde · 13h às 18h</option></select></div>' +
          '</div>' +
          '<p class="pdp__aviso"><strong>Entrega própria</strong> em Brasília e região. ' +
          'No Plano Piloto, no mesmo dia, se o pedido entrar até as 14h.</p>' +
        '</div>';

    /* PERSONALIZAÇÃO. No presente é o cartão de mensagem da referência, com o
       selo "incluso" — é informação de preço, não enfeite: o bilhete não é
       cobrado e ninguém adivinha isso. Na cerimônia o mesmo lugar recebe a
       faixa, SEM caixa e SEM selo (o deck proíbe os dois naquele registro), e
       o preview da fita continua mostrando a normalização. */
    var personalizacao = cerimonia
      ? '<div class="pdp__bloco">' +
          '<h2 class="pdp__rot">A faixa</h2>' +
          '<div class="campo"><label class="campo__r" for="faixa">Nome na faixa</label>' +
          '<input id="faixa" maxlength="60" placeholder="FAMILIA SOUZA LIMA">' +
          '<span class="campo__aj">Ate 60 caracteres. A faixa e impressa em caixa-alta, ' +
          'sem acento e sem pontuacao.</span></div>' +
          '<div class="faixa-preview"><p class="faixa-preview__r">Como vai ficar na fita</p>' +
          '<div class="faixa-fita" id="fitaPrev">&nbsp;</div></div>' +
        '</div>'
      : '<div class="cartao">' +
          '<div class="cartao__topo"><h2 class="cartao__t">Bilhete à mão</h2>' +
          '<span class="cartao__selo">incluso</span></div>' +
          /* "já está no preço da peça" não pode ser dito numa peça SEM preço —
             a frase promete inclusão num número que a página não mostra. Peça
             sob consulta afirma só o que é verdade: o bilhete vai junto. */
          '<p class="cartao__d">Acompanha o arranjo' +
            (E.temPreco(p) ? ' — e já está no preço da peça.' : ', sem custo à parte.') + '</p>' +
          '<div class="campo"><label class="campo__r" for="bilhete">O que escrevemos</label>' +
          '<textarea id="bilhete" maxlength="240" ' +
          'placeholder="Para a Ana — que este ano seja leve. Com amor, João."></textarea>' +
          '<span class="campo__aj"><span data-conta-char>0/240</span> caracteres</span></div>' +
        '</div>';

    /* COMPRA. O contador antes do botão é o da referência. O segundo botão é o
       "comprar agora" dela traduzido para como a banca fecha de verdade: sem
       checkout, a conversa vai para o WhatsApp já com peça, data, janela e
       bilhete escritos. O href não pode vir de `data-whatsapp`: aquele
       listener roda em `ligar()`, ANTES desta página existir. */
    /* PEÇA SEM PREÇO NÃO TEM SACOLA (21/08/2026).
       Contador de quantidade e "colocar na sacola" pressupõem um valor: sem
       ele o carrinho somaria NaN e o checkout mostraria "R$ NaN". Então a
       coluna de compra troca de forma inteira — some o contador, some a
       sacola, e o WhatsApp SOBE de secundário (`--linha`) para primário
       (`--acento`), porque uma tela precisa de exatamente uma ação principal.
       É a mesma mecânica da página de assinaturas, pela mesma razão: o que não
       tem preço fechado é combinado, não é compra. */
    var compra = E.temPreco(p)
      ? '<div class="compra">' +
          '<div class="qtd">' +
            '<button type="button" data-q-menos aria-label="Uma unidade menos">&minus;</button>' +
            '<span data-q aria-live="polite">1</span>' +
            '<button type="button" data-q-mais aria-label="Uma unidade mais">+</button>' +
          '</div>' +
          '<button class="btn btn--acento btn--lg" data-add="' + p.id + '">' +
            (cerimonia ? 'Continuar' : 'Colocar na sacola') + '</button>' +
        '</div>' +
        '<button class="btn btn--linha btn--lg btn--block pdp__zap" type="button" data-zap>' +
          '<i data-lucide="message-circle"></i>' +
          (cerimonia ? 'Falar com a loja' : 'Fechar no WhatsApp') + '</button>'
      : '<button class="btn btn--acento btn--lg btn--block pdp__zap" type="button" data-zap>' +
          '<i data-lucide="message-circle"></i>Pedir o preço no WhatsApp</button>' +
        '<p class="pdp__aviso">Esta peça ainda não tem preço publicado. A loja responde ' +
        'com o valor e com o que tem de bom no mercado no dia da entrega.</p>';

    var fotos = fotosDe(p, cerimonia);

    /* A linha de economia ocupa o lugar do "R$ X no PIX" da referência. Não é
       tradução: desconto no PIX é preço, e nenhum preço deste protótipo veio
       da loja. O que o catálogo TEM é o `de` de quem está em promoção — então
       é isso que aparece, e só em quem tem. */
    alvo.innerHTML =
      '<div class="pdp">' +
        /* OS DOIS BLOCOS TROCARAM DE LADO EM 19/08/2026, a pedido do Erik:
           as FICHAS DE PROVA vieram para a coluna A e os ACORDEÕES foram para
           o pé da coluna B.
           O que isso muda na leitura, e vale saber antes de desfazer: a divisão
           por papel que valia desde 17/08 era A = conhecer a peça / B = decidir
           e comprar, com a prova encostada no botão porque ela responde a dúvida
           de quem está com o dedo nele. Agora a prova fecha a coluna da FOTO
           (procedência ao lado da peça) e os acordeões fecham a coluna de
           compra (a letra miúda depois do preço). É outra divisão, não a mesma
           com os blocos trocados.
           A régua de equilíbrio do §8 do README continua valendo: as duas
           colunas foram remedidas depois da troca. */
        '<div class="pdp__a">' +
          galeria(p, fotos) +
          tira(cerimonia) +
          fichas(cerimonia) +
        '</div>' +
        '<div class="pdp__b">' +
          (cat ? '<a class="pdp__cat" href="' + edwCol(p.cat) + '">' +
                 cat.nome + '</a>' : '') +
          '<h1 class="pdp__n">' + p.nome + '</h1>' +
          /* A NOTA POR PRODUTO SAIU DAQUI EM 17/08/2026, e é decisão de conteúdo:
             a loja não coleta avaliação por peça — o site atual não tem isso em
             lugar nenhum, e os campos `nota`/`avaliacoes` do `PRODUTOS` são
             ilustrativos como os preços. Uma estrela com "4,9 (128)" na página
             que fecha a venda é o tipo de número que ninguém consegue justificar
             se o cliente perguntar de onde veio.
             A prova social que a página mantém é a REAL: 5,0 de 11 no Google,
             com link para a ficha, no bloco de provas da coluna da esquerda.
             Os cartões da PLP e da home ainda mostram a nota — decisão pendente
             com o Erik, porque mexer neles muda outras duas páginas. */
          '<p class="pdp__p' + (E.temPreco(p) ? '' : ' pdp__p--consulta') + '">' +
            (E.temPreco(p) ? money(p.preco) : 'Sob consulta') + '</p>' +
          (cerimonia || !E.temPreco(p) ? '' : '<p class="pdp__parc">' + E.PARCELAS + 'x de ' +
            money(p.preco / E.PARCELAS) + ' sem juros</p>') +
          (cerimonia || !p.de || !E.temPreco(p) ? '' : '<p class="pdp__econ">' +
            '<span class="pdp__de">' + money(p.de) + '</span> · você economiza ' +
            money(p.de - p.preco) + '</p>') +
          '<p class="pdp__d">' + (p.resumo || '') + '</p>' +
          entrega +
          (cerimonia ? personalizacao : '') +
          compra +
          (cerimonia ? '' : personalizacao) +
          (cerimonia ? '' : junto(p)) +
          garantias(cerimonia) +
          acordeoes(p, cerimonia) +
        '</div>' +
      '</div>';

    /* A faixa vai NORMALIZADA para o pedido — sem acento e sem pontuação,
       como o deck manda. O campo aceita; a fita corrige. */
    var campoFaixa = $('#faixa'), prev = $('#fitaPrev');
    if (campoFaixa && prev) {
      var atualizar = function () { prev.textContent = semAcento(campoFaixa.value) || ' '; };
      campoFaixa.addEventListener('input', atualizar);
      atualizar();
    }

    var hoje = new Date();
    var iso = hoje.getFullYear() + '-' + String(hoje.getMonth() + 1).padStart(2, '0') +
              '-' + String(hoje.getDate()).padStart(2, '0');
    $$('input[type="date"]').forEach(function (d) { if (!d.min) d.min = iso; });

    /* GALERIA. Troca o src do palco em vez de empilhar as fotos e escondê-las:
       com duas ou três imagens não vale carregar todas de uma vez, e o
       contador e a legenda precisariam de sincronia extra. */
    var palco = $('.gal__foto');
    var contaFoto = $('[data-conta-foto]');
    var papel = $('[data-papel]');
    var botoesFoto = $$('.gal__thumb');

    function irPara(i) {
      var f = fotos[i];
      if (!f || !palco) return;
      palco.src = f.src;
      palco.style.objectPosition = f.pos || '';
      if (contaFoto) contaFoto.textContent = (i + 1) + '/' + fotos.length;
      if (papel) {
        papel.textContent = f.papel || '';
        if (f.papel) { papel.removeAttribute('hidden'); } else { papel.setAttribute('hidden', ''); }
      }
      botoesFoto.forEach(function (b, j) {
        if (j === i) { b.setAttribute('aria-current', 'true'); }
        else { b.removeAttribute('aria-current'); }
      });
    }
    botoesFoto.forEach(function (b) {
      b.addEventListener('click', function () { irPara(+b.getAttribute('data-ir')); });
    });
    irPara(0);

    /* COMPARTILHAR. `navigator.share` só existe em contexto seguro, na prática
       no celular; fora dele copia o link e avisa NO PRÓPRIO BOTÃO. Nada de
       alert() aqui: um diálogo modal congela a página inteira e trava
       qualquer print ou automação, como já aconteceu neste projeto. */
    var share = $('[data-share]');
    if (share) {
      share.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: p.nome + ' · Floricultura Edelweiss', url: location.href })
            .catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(location.href).then(function () {
            share.setAttribute('data-copiado', '');
            setTimeout(function () { share.removeAttribute('data-copiado'); }, 2200);
          }, function () {});
        }
      });
    }

    /* QUANTIDADE. Teto de 20 porque a banca monta na hora: pedido de festa é
       conversa com a loja, não botão de "+" apertado vinte e uma vezes. */
    var qtd = 1;
    var vq = $('[data-q]'), qMenos = $('[data-q-menos]'), qMais = $('[data-q-mais]');
    function pintarQtd() {
      if (vq) vq.textContent = qtd;
      if (qMenos) qMenos.disabled = qtd <= 1;
      if (qMais)  qMais.disabled  = qtd >= 20;
    }
    if (qMenos) qMenos.addEventListener('click', function () { if (qtd > 1)  { qtd--; pintarQtd(); } });
    if (qMais)  qMais.addEventListener('click',  function () { if (qtd < 20) { qtd++; pintarQtd(); } });
    pintarQtd();

    var bilhete = $('#bilhete'), contaChar = $('[data-conta-char]');
    if (bilhete && contaChar) {
      var pintarChar = function () { contaChar.textContent = bilhete.value.length + '/240'; };
      bilhete.addEventListener('input', pintarChar);
      pintarChar();
    }

    function propriedades() {
      var props = {};
      if (cerimonia) {
        if (campoFaixa && campoFaixa.value) props['Faixa impressa'] = semAcento(campoFaixa.value);
        if ($('#hora') && $('#hora').value)   props['Hora marcada'] = $('#hora').value;
        if ($('#local') && $('#local').value) props['Local'] = $('#local').value;
      } else {
        if ($('#bilhete') && $('#bilhete').value) props['Bilhete'] = $('#bilhete').value;
        if ($('#janela'))  props['Janela'] = $('#janela').value;
      }
      if ($('#dia') && $('#dia').value) props['Data'] = $('#dia').value;
      return props;
    }

    function marcados() {
      return $$('[data-junto]').filter(function (c) { return c.checked; });
    }

    var add = $('[data-add]');
    if (add) {
      add.addEventListener('click', function () {
        var props = propriedades();
        var extras = marcados();
        /* Quem abre a gaveta é o ÚLTIMO da fila — por isso o `silencio` do
           app.js. Sem ele a sacola abriria uma vez por item, e o redesenho de
           cada chamada seria jogado fora pelo seguinte. */
        E.adicionar(p.id, Object.keys(props).length ? props : null, qtd, extras.length > 0);
        extras.forEach(function (c, i) {
          E.adicionar(c.getAttribute('data-junto'), null, 1, i < extras.length - 1);
          c.checked = false;
        });
      });
    }

    var zap = $('[data-zap]');
    if (zap) {
      zap.addEventListener('click', function () {
        var props = propriedades();
        /* Sem preço a linha vira PERGUNTA, não recibo: mandar "1x Buquê - R$ NaN"
           é o que acontecia antes do `temPreco`, e é o tipo de erro que chega no
           WhatsApp da loja, não no console. */
        var linhas = ['Ola, vim pelo site.',
                      E.temPreco(p)
                        ? qtd + 'x ' + p.nome + ' - ' + money(p.preco * qtd)
                        : p.nome + ' - queria saber o preco e a disponibilidade'];
        Object.keys(props).forEach(function (k) { linhas.push(k + ': ' + props[k]); });
        marcados().forEach(function (c) {
          var o = produto(c.getAttribute('data-junto'));
          if (o) linhas.push('Levar junto: ' + o.nome + ' - ' + money(o.preco));
        });
        window.open('https://wa.me/' + E.WHATSAPP + '?text=' +
          encodeURIComponent(linhas.join('\n')), '_blank');
      });
    }
    icones();
  }

  document.addEventListener('DOMContentLoaded', function () {
    montarPLP();
    montarPDP();
  });
})();
